import { useEffect, useMemo, useState } from 'react';
import api from '../../services/api';

function SANotifications() {
  const [rows, setRows] = useState([]);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await api.getAdminNotifications();
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.message || 'Failed to load notifications');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const unread = useMemo(() => rows.filter((n) => n.unread || !n.is_read).length, [rows]);

  const markOne = async (id) => {
    try {
      await api.markAdminNotificationRead(id);
      setRows((prev) => prev.map((n) => (n.id === id ? { ...n, unread: false } : n)));
    } catch (_) { }
  };

  const markAll = async () => {
    try {
      await api.markAllAdminNotificationsRead();
      setRows((prev) => prev.map((n) => ({ ...n, unread: false })));
    } catch (_) { }
  };

  return (
    <div className="sa-card" style={{ minHeight: 540 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 800, fontFamily: "'Sora', sans-serif" }}>Block & Exit Notifications</div>
          <div style={{ fontSize: 12, color: 'var(--sa-muted)', marginTop: 4 }}>{unread} unread</div>
        </div>
        <button className="sa-action-btn" onClick={markAll}>Mark all as read</button>
      </div>

      {loading ? <div style={{ padding: 24, color: 'var(--sa-muted)' }}>Loading...</div> : null}
      {error ? <div style={{ padding: 12, border: '1px solid rgba(229,57,53,.2)', borderRadius: 10, color: '#ff8f8f', marginBottom: 10 }}>{error}</div> : null}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <div style={{ border: '1px solid var(--sa-border)', borderRadius: 12, overflow: 'hidden' }}>
          {rows.length === 0 ? (
            <div style={{ padding: 18, color: 'var(--sa-muted)' }}>No notifications yet.</div>
          ) : (
            rows.map((n) => (
              <div
                key={n.id}
                onClick={() => { setActive(n); markOne(n.id); }}
                style={{
                  padding: '12px 14px',
                  borderBottom: '1px solid var(--sa-border)',
                  cursor: 'pointer',
                  background: active?.id === n.id ? 'rgba(229,57,53,.08)' : 'transparent'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--sa-text)' }}>{n.title || 'Notification'}</div>
                  {(n.unread || !n.is_read) ? <span style={{ width: 8, height: 8, borderRadius: 8, background: '#E53935', marginTop: 5 }} /> : null}
                </div>
                <div style={{ marginTop: 4, fontSize: 12, color: 'var(--sa-muted)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {n.body || ''}
                </div>
              </div>
            ))
          )}
        </div>

        <div style={{ border: '1px solid var(--sa-border)', borderRadius: 12, padding: 16, minHeight: 240 }}>
          {!active ? (
            <div style={{ color: 'var(--sa-muted)', fontSize: 13 }}>Select a notification to view details.</div>
          ) : (
            <div>
              <div style={{ fontSize: 18, fontWeight: 800, fontFamily: "'Sora', sans-serif", marginBottom: 8 }}>{active.title}</div>
              <div style={{ fontSize: 12, color: 'var(--sa-dim)', marginBottom: 14 }}>
                {new Date(active.created_at).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' })}
              </div>
              <div style={{ background: 'rgba(255,255,255,.03)', border: '1px solid var(--sa-border)', borderRadius: 10, padding: 12, lineHeight: 1.5 }}>
                {active.body}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SANotifications;
